<template>
  <div class="client-login-container">
    <!-- 背景层：科技深蓝几何渐变与光晕 -->
    <div class="bg-layer">
      <div class="glow-orb orb-1"></div>
      <div class="glow-orb orb-2"></div>
      <div class="grid-mesh"></div>
    </div>

    <!-- 登录主卡片（左侧平台宣言 + 右侧登录操作） -->
    <div class="login-wrapper">
      <!-- 左侧政企采购宣传面板 -->
      <div class="brand-panel">
        <div class="brand-top">
          <div class="brand-badge">
            <i class="el-icon-lock"></i>
            <span>政企专属 · 阳光采购平台</span>
          </div>
          <h1 class="brand-title">杭州科普特电子<br />数字化物资采购协同系统</h1>
          <p class="brand-subtitle">
            集约化供应链服务，提供医疗器械、实验室耗材与特种工业物资的全链路数字化直供保障。
          </p>
        </div>

        <div class="feature-list">
          <div class="feature-item">
            <div class="icon-wrap"><i class="el-icon-document-checked"></i></div>
            <div class="text-wrap">
              <h4>阳光透明 · 合规审计</h4>
              <p>全流程在线留痕，自动关联科室预算与采购批次</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="icon-wrap"><i class="el-icon-connection"></i></div>
            <div class="text-wrap">
              <h4>ERP 对账 · 极速流转</h4>
              <p>支持协议月结与微信快捷结算，发票对账自动化</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="icon-wrap"><i class="el-icon-medal"></i></div>
            <div class="text-wrap">
              <h4>正品直供 · 恒温仓配</h4>
              <p>原厂质保直供，专业医疗冷链与专属直通车配送</p>
            </div>
          </div>
        </div>

        <div class="brand-footer">
          <span>客服支持：0571-88888888</span>
          <span class="divider">|</span>
          <span>工作日 8:30 - 17:30</span>
        </div>
      </div>

      <!-- 右侧登录表单面板 -->
      <div class="form-panel">
        <div class="form-header">
          <div class="logo-mark">
            <i class="el-icon-s-platform"></i>
          </div>
          <h2 class="welcome-text">欢迎登录</h2>
          <p class="sub-text">请输入您的企业采购员账号或工号</p>
        </div>

        <el-form class="login-form" @submit.native.prevent="login">
          <el-form-item>
            <el-input
              v-model="username"
              placeholder="请输入企业账号 / 员工工号"
              prefix-icon="el-icon-user"
              clearable
              size="large"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-input
              v-model="password"
              type="password"
              show-password
              placeholder="请输入登录密码"
              prefix-icon="el-icon-lock"
              size="large"
              @keyup.enter.native="login"
            ></el-input>
          </el-form-item>

          <div class="form-helper">
            <el-checkbox v-model="rememberMe">记住账号</el-checkbox>
            <span class="forget-link" @click="handleForget">忘记密码？</span>
          </div>

          <el-button
            type="primary"
            class="btn-login-submit"
            :loading="loading"
            @click="login"
          >
            {{ loading ? '正在验证身份...' : '登 录 采 购 平 台' }}
          </el-button>
        </el-form-item>
        </el-form>

        <div class="security-cert">
          <i class="el-icon-circle-check"></i>
          <span>国标 SSL 256 位加密连接 · 全链路操作安全审计保护</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { login } from "@/api/platform";

export default {
  name: "ClientLogin",
  data () {
    return {
      username: '',
      password: '',
      rememberMe: true,
      loading: false,
    };
  },
  mounted () {
    const savedUser = localStorage.getItem('kpt_login_user');
    if (savedUser) {
      this.username = savedUser;
    }
  },
  methods: {
    ...mapMutations({
      setClientName: "SET_CLIENT_NAME",
      setClientToken: "SET_CLIENT_TOKEN",
    }),
    handleForget () {
      this.$alert('请联系贵单位采购管理员或拨打技术支持电话 0571-88888888 协助重置密码。', '密码找回指引', {
        confirmButtonText: '我知道了',
        type: 'info'
      });
    },
    async login () {
      if (!this.username.trim()) {
        return this.$message.warning('请输入登录账号或工号');
      }
      if (!this.password) {
        return this.$message.warning('请输入密码');
      }

      this.loading = true;
      try {
        const { result } = await login({
          username: this.username.trim(),
          password: this.password,
        });

        if (this.rememberMe) {
          localStorage.setItem('kpt_login_user', this.username.trim());
        } else {
          localStorage.removeItem('kpt_login_user');
        }

        this.setClientToken(result.token);
        this.setClientName(result.name);
        localStorage.setItem("user", JSON.stringify(result));

        this.$message.success(`欢迎回来，${result.name || '采购员'}！`);
        this.$router.push("/");
      } catch (e) {
        this.$message.error(e && e.message ? e.message : '账号或密码错误，请核对后重试');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';

.client-login-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0b192c;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;

  /* 背景渐变与特效 */
  .bg-layer {
    position: absolute;
    inset: 0;
    background: radial-gradient(circle at 15% 25%, #1e3a8a 0%, #0b192c 60%, #030712 100%);
    z-index: 1;

    .glow-orb {
      position: absolute;
      border-radius: 50%;
      filter: blur(90px);
      opacity: 0.25;
      pointer-events: none;

      &.orb-1 {
        width: 500px;
        height: 500px;
        top: -100px;
        left: -100px;
        background: #3b82f6;
      }

      &.orb-2 {
        width: 400px;
        height: 400px;
        bottom: -50px;
        right: 15%;
        background: #0ea5e9;
      }
    }

    .grid-mesh {
      position: absolute;
      inset: 0;
      background-image: linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
                        linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
      background-size: 40px 40px;
    }
  }

  /* 登录卡片 */
  .login-wrapper {
    position: relative;
    z-index: 2;
    display: flex;
    width: 980px;
    height: 580px;
    border-radius: 16px;
    background: #ffffff;
    box-shadow: 0 25px 60px -15px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.1);
    overflow: hidden;

    /* 左侧品牌面板 */
    .brand-panel {
      flex: 1.1;
      background: linear-gradient(145deg, #0f52ba 0%, #0a3d8f 100%);
      padding: 48px;
      color: #ffffff;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      position: relative;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: radial-gradient(circle at 100% 0%, rgba(255, 255, 255, 0.12) 0%, transparent 60%);
        pointer-events: none;
      }

      .brand-top {
        .brand-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: rgba(255, 255, 255, 0.15);
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 500;
          letter-spacing: 0.5px;
          margin-bottom: 20px;
          backdrop-filter: blur(4px);
        }

        .brand-title {
          font-size: 26px;
          line-height: 1.35;
          font-weight: 800;
          margin: 0 0 14px;
          letter-spacing: -0.5px;
        }

        .brand-subtitle {
          font-size: 13px;
          line-height: 1.6;
          color: rgba(255, 255, 255, 0.8);
          margin: 0;
        }
      }

      .feature-list {
        display: flex;
        flex-direction: column;
        gap: 20px;
        margin: 24px 0;

        .feature-item {
          display: flex;
          align-items: center;
          gap: 14px;

          .icon-wrap {
            width: 38px;
            height: 38px;
            border-radius: 8px;
            background: rgba(255, 255, 255, 0.12);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
            flex-shrink: 0;
          }

          .text-wrap {
            h4 {
              margin: 0 0 3px;
              font-size: 14px;
              font-weight: 600;
            }

            p {
              margin: 0;
              font-size: 12px;
              color: rgba(255, 255, 255, 0.7);
            }
          }
        }
      }

      .brand-footer {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.6);
        display: flex;
        align-items: center;
        gap: 8px;

        .divider {
          opacity: 0.4;
        }
      }
    }

    /* 右侧表单面板 */
    .form-panel {
      flex: 1;
      padding: 48px 44px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      background: #ffffff;

      .form-header {
        .logo-mark {
          width: 44px;
          height: 44px;
          border-radius: 10px;
          background: #eff6ff;
          color: @brandPrimary;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          margin-bottom: 16px;
        }

        .welcome-text {
          font-size: 24px;
          font-weight: 800;
          color: #0f172a;
          margin: 0 0 6px;
        }

        .sub-text {
          font-size: 13px;
          color: #64748b;
          margin: 0;
        }
      }

      .login-form {
        margin-top: 10px;

        /deep/ .el-input__inner {
          height: 46px;
          line-height: 46px;
          border-radius: 8px;
          font-size: 14px;
          border-color: #cbd5e1;

          &:focus {
            border-color: @brandPrimary;
            box-shadow: 0 0 0 3px rgba(15, 82, 186, 0.12);
          }
        }

        .form-helper {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 4px 0 24px;

          .forget-link {
            font-size: 13px;
            color: #64748b;
            cursor: pointer;

            &:hover {
              color: @brandPrimary;
            }
          }
        }

        .btn-login-submit {
          width: 100%;
          height: 46px;
          font-size: 15px;
          font-weight: 700;
          letter-spacing: 1px;
          border-radius: 8px;
          background-color: @brandPrimary;
          border-color: @brandPrimary;
          transition: all 0.25s ease;

          &:hover {
            background-color: @brandSecondary;
            border-color: @brandSecondary;
            box-shadow: 0 6px 18px rgba(15, 82, 186, 0.3);
            transform: translateY(-1px);
          }
        }
      }

      .security-cert {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        font-size: 12px;
        color: #94a3b8;
        padding-top: 14px;
        border-top: 1px solid #f1f5f9;

        i {
          color: #10b981;
          font-size: 14px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/client/MallLogin.vue